import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {selectIsOnesided, selectIsSingle, selectLdt1, selectLdt2, selectMountingInstruction} from '../../../selectors';

@customElement('page-diagram')
export class PageDiagram extends connect(store)(LitElement) {

	static styles = css`
	  a {
		color: #000;
	  }
	  .page-container {
		  display: flex;
		  margin: var(--specsheet-medium-gap) var(--specsheet-large-gap);
	}

	.diagrams {
		width: 50%;
		padding-left: var(--specsheet-large-gap);
	}

	.description {
		font: var(	--font-specsheet-light);
		width: 46%;
	}

	.image {
		margin-top:  var(--specsheet-large-gap);
	}

	.downloads {
		font: var(	--font-specsheet-light);
	}

	@media print {
		font: var(	--font-specsheet-print-light);
	}



	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
	}

	render() {

		return html`

		<div class="page-container">
			<div class="diagrams">
				<trans-label slot="title" key="TE_Dimensions" context="D"></trans-label>
				<div class="image">
					<div slot="content">
						<line-drawing></line-drawing>
					</div>
				</div>
			</div>

			<div class="description">
					<span class="downloads">Downloads</span>
					<div class="downloads">
						${when(selectMountingInstruction(this.state) !== null, () => html`
							<a href="${selectMountingInstruction(this.state)}"
						   target="_blank">${msg('Mounting instruction')}</a><br>
						`)}
						${when(selectLdt1(this.state) !== null, () => html`
							<a href="${selectLdt1(this.state)}" target="_blank">${msg('LDT Side')} A</a><br>
						`)}
						${when(!selectIsOnesided(this.state) && selectLdt2(this.state) !== null, () => html`
							<a href="${selectLdt2(this.state)}" target="_blank">${msg('LDT Side')} B</a><br>
						`)}
					</div>

			</div>
		</div>

		`;
	}
}
